// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackUserEditedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/user/trackUserEdited";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackUserEdited = (
    parameters: PartialSpecific<TrackUserEditedParameters, "has_approver" | "role"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.userEdited, parameters, options);
};

export default useTrackUserEdited;
